import React from "react";
import {
  Typography,
  Grid,
  Card,
  Badge,
  withStyles,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import background from "../../../assets/images/background.png";

import InfoIcon from "../../../assets/icons/InfoIcon.png";
import CartIcon from "../../../assets/icons/CartIcon.png";
import CrossIcon from "../../../assets/icons/CrossIcon.png";
import { useSelector } from "react-redux";
import style from "./style.module.css";
import _ from "lodash";
import { useSnackbar } from "notistack";
import { relativeTimeRounding } from "moment";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 10,
    top: 10,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
    color: "white",
  },
}))(Badge);

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    fontSize: 13,
  },
}));
function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow placement="left" classes={classes} {...props} />;
}

const ProductItem = ({
  product,
  productImage,
  productName,
  productDetail,
  productPrice,
  onClick,
  isSelected,
  stock,
  onRemove,
  onAdd,
  onIncrement,
  onDecrement,
}) => {
  const cartItems = useSelector((state) => state.touchless.cart_items);
  const currency = useSelector((state) => state.touchless.currency);
  const quantity = _.find(cartItems, (x) => x.id === product.id)?.quantity;
  const themeData = useSelector((state) => state.touchless.theme);
  const shopLimit = useSelector((state) => state.touchless.shopLimit);
  const { enqueueSnackbar } = useSnackbar();
  const {
    name,
    primary_color ,
    secondary_color ,
    text_button_color ,
    item_background_img_url ,
    item_background_opacity ,
} = themeData || {};
  
  const effectiveTextColor = text_button_color || secondary_color;

  var final_item_background_img_url = item_background_img_url
  if( item_background_img_url==""){

    final_item_background_img_url="";//in future add default item background img url here 
  }

  // const cssOpacityItem = item_background_opacity && !isNaN(item_background_opacity) 
  // ? item_background_opacity / 100 
  // : 0.0


  const cssOpacityItem = item_background_opacity && !isNaN(item_background_opacity) ?
                          item_background_opacity>0?
                          1- item_background_opacity / 100 :1//here if zero is sent it will adapt
                          :name!=="default"?  
                          item_background_img_url? 0 : 1 : 0;
  
  const totalQuantity = React.useMemo(
    () => cartItems.reduce((acc, value) => (acc += value.quantity), 0),
    [cartItems]
  );

  const handleCart = (product, isSelected) => {
    if (product.stock <= 0) {
      return;
    }

    if (isSelected) {
      if (quantity === 1) {
        onRemove(product.id);
      } else {
        onDecrement(product.id);
      }
    } else {
      if (product.stock <= 0 || quantity + 1 === stock) {
        return;
      }

      if (totalQuantity >= shopLimit) {
        enqueueSnackbar(`Only ${shopLimit} item(s) can be added per checkout`, {
          preventDuplicate: true,
        });
        return;
      }

      if (!quantity || quantity < 0) {
        onAdd(product);
      } else {
        onIncrement(product.id);
      }
    }
  };

  return (
    <Grid item xm={6} xs={6} sm={4}>
      <Card
        style={{
          margin: "0.5em",
          borderRadius: 20,
          paddingTop: 20,
          position: "relative",
          textAlign: "center",
        }}
      >
        <div
          style={{
            height: 150,
          }}
        >
          <div
        style={{
          position: "relative",
          backgroundImage: name =="default"?`url(${""})`:`url(${final_item_background_img_url})`,
          backgroundSize: "cover", // Using 'cover' might be more suitable for a full background
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: "100%",
          width: "100%",
        }}
      >
          {/* Opacity Layer */}
          <div
            style={{
              position: "absolute", // Positions the opacity layer directly over the background
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              opacity:  name =="default"? 0.00:cssOpacityItem,
              backgroundColor: "white", // Semi-transparent black layer, adjust color and opacity as needed
            }}
          ></div>

        <div
          style={{
            position: "absolute", // Use 'absolute' positioning to layer on top of the background
            top: "2%", // Creates space from the top edge
            left: "2%", // Creates space from the left edge
            right: "2%", // Creates space from the right edge
            bottom: "2%", // Creates space from the bottom edge
            backgroundImage: `url(${productImage})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            height: "90%", // Reduces height relative to the parent
            width: "90%", // Reduces width relative to the parent
          }}
        />
      </div>

        </div>
        <div className={style.scroll_container}>
          {name=="default"?  <div className={style.scrollbar_hidden}>
            <Typography style={{ fontWeight: 600, fontSize: "0.9rem" }}>
              {productName}
            </Typography>
          </div>
          :
          <div className={style.scrollbar_hidden}>
            <Typography style={{ fontWeight: 600, fontSize: "0.9rem", color:secondary_color}}>
              {productName}
            </Typography>
          </div>
          }
        </div>
        {name==="default"?
        <Typography
        variant="h6"
        style={{ fontWeight: 600, color: "#949494", paddingBottom: 25 }}
      >
        {productDetail}
      </Typography>:
        <Typography
        variant="h6"
        style={{ fontWeight: 600, paddingBottom: 25, color:secondary_color}}
      >
        {productDetail}
      </Typography>
        }
        
        {product.stock === 0 && (
          <Card
            variant="outlined"
            style={{
              position: "absolute",
              top: "45%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-30deg)",
              padding: "4px 8px",
            }}
          >
            <Typography
              variant="body2"
              style={{
                fontWeight: "bold",
                fontSize: "1rem",
                whiteSpace: "nowrap",
              }}
            >
              Out of Stock
            </Typography>
          </Card>
        )}
      </Card>
      <Grid
        container
        style={{ position: "relative", bottom: 34, padding: "0px 8px" }}
      >
        <Grid
          item
          xs={12}
          onClick={() => {

            if (totalQuantity >= shopLimit) {
              enqueueSnackbar(`Only ${shopLimit} item(s) can be added per checkout`, {
                preventDuplicate: true,
              });
              return;
            }

            if (product.stock <= 0 || quantity + 1 > stock) {
              enqueueSnackbar(`Only ${product.stock} items are available`, {
                preventDuplicate: true,
              });
              return;
            }

            if (!quantity || quantity < 0) {
              onAdd(product);
            } else {
              onIncrement(product.id);
            }
          }}
        >
          <Card
           style={{
            ...(name === "default"
              ? (!isSelected
                  ? {
                      backgroundImage: "linear-gradient(to bottom, #0da1f7ba 0%, #0d66f7 100%)",
                      boxShadow: "0px 4px 7px #0d68f7",
                    }
                  : {
                      backgroundImage: "linear-gradient(#77cf12 0%, #008906 100%)",
                      boxShadow: "rgb(51 239 59 / 68%) 0px 4px 7px",
                    })
              : (!isSelected
                  ? {
                      backgroundColor: primary_color,
                      boxShadow: `0px 4px 7px ${primary_color}`,
                    }
                  : {
                      backgroundImage: "linear-gradient(#77cf12 0%, #008906 100%)",
                      boxShadow: "rgb(51 239 59 / 68%) 0px 4px 7px",
                    })),
            borderRadius: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            padding: "0 6px 0 2px",
          }}
          
          >
            <StyledBadge
              badgeContent={quantity}
              overlap="circle"
              color="primary"
            >
          <Grid style={{ height: 42, width: 50 }}>
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleCart(product, isSelected);
            }}
            style={{
              height: "100%", // Ensuring the container fits its parent
              marginTop: 8,
              marginLeft: 8,
            }}
          >
            {!isSelected ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill={name==="default"?"white":effectiveTextColor} d="M11,9H13V6H16V4H13V1H11V4H8V6H11M7,18C5.9,18 5,18.9 5,20S5.9,22 7,22 9,21.1 9,20 8.1,18 7,18M17,18C15.9,18 15,18.9 15,20S15.9,22 17,22 19,21.1 19,20 18.1,18 17,18M7.2,14.8V14.7L8.1,13H15.5C16.2,13 16.9,12.6 17.2,12L21.1,5L19.4,4L15.5,11H8.5L4.3,2H1V4H3L6.6,11.6L5.2,14C5.1,14.3 5,14.6 5,15C5,16.1 5.9,17 7,17H19V15H7.4C7.3,15 7.2,14.9 7.2,14.8Z"/>
              </svg>
            ) : (
              <div style={{
                width: "32px",
                height: "32px",
                backgroundImage: `url(${CrossIcon})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center"
              }} />
            )}
          </div>
        </Grid>
            </StyledBadge>
            <div style={{ flex: 1 }}>
              <BootstrapTooltip title={`${currency} ${parseFloat(productPrice || 0).toFixed(2)}`}>
                <Typography
                  variant="body2"
                  style={{
                    color:name==="default"?"white":effectiveTextColor,
                    marginRight: "20",
                    fontSize: "18px",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                  }}
                >
                  {currency + " " + parseFloat(productPrice || 0).toFixed(2)}
                </Typography>
              </BootstrapTooltip>
            </div>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProductItem;
